import { dataSkipForward } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSkipForward = /*#__PURE__*/createIcon(dataSkipForward)
export default IconSkipForward
